import type { IconKey } from "@core/assets";
import type { TProjectRole } from "@modules/project/_shared/types";

export type TProjectNavItem = {
  key: string;
  path: string;
  /** i18n key relative to workspace.* namespace (consumed by useTranslate) */
  labelKey: string;
  /** Valid IconKey name — resolved via icons[key] in the sidebar */
  icon: IconKey;
  roles: TProjectRole[];
  badge?: string;
};

export type TProjectNavSection = {
  /** i18n key relative to workspace.* namespace */
  sectionKey: string;
  items: TProjectNavItem[];
};

export const PROJECT_NAV: TProjectNavSection[] = [
  {
    sectionKey: "sidebar.sections.general",
    items: [
      {
        key: "team",
        path: "team",
        labelKey: "sidebar.nav.team",
        icon: "users",
        roles: ["project_admin"],
      },
      {
        key: "activity",
        path: "activity",
        labelKey: "sidebar.nav.activity",
        icon: "activity",
        roles: ["project_admin"],
        badge: "beta",
      },
    ],
  },
  {
    sectionKey: "sidebar.sections.docs",
    items: [
      {
        key: "documents",
        path: "documents",
        labelKey: "sidebar.nav.documents",
        icon: "folder",
        roles: ["project_admin", "member"],
      },
      {
        key: "approvals",
        path: "approvals",
        labelKey: "sidebar.nav.approvals",
        icon: "circle-check-big",
        roles: ["project_admin", "member"],
      },
      {
        key: "trash",
        path: "trash",
        labelKey: "sidebar.nav.trash",
        icon: "trash-2",
        roles: ["project_admin"],
      },
    ],
  },
];

export const PROJECT_FOOTER_NAV: TProjectNavItem[] = [
  {
    key: "settings",
    path: "settings",
    labelKey: "sidebar.nav.settings",
    icon: "settings",
    roles: ["project_admin"],
  },
];

/** Flat list of all nav items — used by ProjectRouteGuard */
export const ALL_PROJECT_NAV_ITEMS: TProjectNavItem[] = [
  ...PROJECT_NAV.flatMap((s) => s.items),
  ...PROJECT_FOOTER_NAV,
];
